// ANNUBIS — scripts propios (vanilla, sin librerías)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initMobileDrawer();
  initDropdownTouch();
  initProductGallery();
  initVariantPicker();
  initQty();
  initAccordion();
  initZoom();
  initReviewsScroll();
  initDiscountPopup();
  initChipbarActive();
});

function initChipbarActive() {
  document.querySelectorAll('[data-an-chipbar]').forEach(function (bar) {
    var segments = window.location.pathname.split('/').filter(Boolean);
    var current = (segments[0] === 'collections' && segments.length >= 3) ? segments[2] : '';
    var chips = bar.querySelectorAll('.an-chip');
    var matched = false;
    chips.forEach(function (chip) {
      if (chip.dataset.filter === current && current !== '') {
        chip.classList.add('is-active');
        matched = true;
      }
    });
    if (!matched) {
      var allChip = bar.querySelector('.an-chip[data-filter=""]');
      if (allChip) allChip.classList.add('is-active');
    }
  });
}

function initDiscountPopup() {
  var popup = document.querySelector('[data-an-popup]');
  if (!popup) return;
  var closeBtn = popup.querySelector('.an-popup__close');
  var backdrop = popup.querySelector('.an-popup__backdrop');
  var copyBtn = popup.querySelector('[data-an-copy-code]');
  var storageKey = 'an_popup_seen';

  function open() { popup.classList.add('is-open'); }
  function close() {
    popup.classList.remove('is-open');
    try { localStorage.setItem(storageKey, '1'); } catch (e) {}
  }

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.dataset.code || '';
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = '¡Copiado!';
          setTimeout(function () { copyBtn.textContent = original; }, 1800);
        });
      }
    });
  }

  if (popup.dataset.success === 'true') {
    open();
    try { localStorage.setItem(storageKey, '1'); } catch (e) {}
    return;
  }

  var alreadySeen = false;
  try { alreadySeen = localStorage.getItem(storageKey) === '1'; } catch (e) {}
  if (alreadySeen) return;

  var delay = parseInt(popup.dataset.delay || '5', 10) * 1000;
  setTimeout(open, delay);
}

function initReveal() {
  var els = document.querySelectorAll('.an-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('an-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = el.dataset.anDelay || (i * 60);
        setTimeout(function () { el.classList.add('an-visible'); }, delay);
        io.unobserve(el);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initMobileDrawer() {
  var drawer = document.querySelector('.an-mobile-drawer');
  var openBtn = document.querySelector('.an-burger');
  if (!drawer || !openBtn) return;
  var closeBtn = drawer.querySelector('.an-mobile-drawer__close');
  var backdrop = drawer.querySelector('.an-mobile-drawer__backdrop');
  function open() { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);
  drawer.querySelectorAll('.an-mobile-nav__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var li = btn.closest('li');
      if (!li.querySelector('.an-mobile-nav__sub')) return;
      var wasOpen = li.classList.contains('is-open');
      drawer.querySelectorAll('.an-mobile-nav > li').forEach(function (l) { l.classList.remove('is-open'); });
      if (!wasOpen) li.classList.add('is-open');
    });
  });
}

function initDropdownTouch() {
  // En touch, el primer tap abre el desplegable en vez de navegar directo
  var items = document.querySelectorAll('.an-nav > li');
  items.forEach(function (li) {
    var dropdown = li.querySelector('.an-dropdown');
    if (!dropdown) return;
    var link = li.querySelector('.an-nav__link');
    link.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && !li.classList.contains('is-touch-open')) {
        e.preventDefault();
        document.querySelectorAll('.an-nav > li.is-touch-open').forEach(function (l) { l.classList.remove('is-touch-open'); });
        li.classList.add('is-touch-open');
        dropdown.style.opacity = '1';
        dropdown.style.visibility = 'visible';
        dropdown.style.pointerEvents = 'auto';
        dropdown.style.transform = 'translate(-50%, 0)';
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.an-nav > li')) {
      document.querySelectorAll('.an-nav > li.is-touch-open').forEach(function (l) {
        l.classList.remove('is-touch-open');
        var d = l.querySelector('.an-dropdown');
        if (d) { d.style.opacity = ''; d.style.visibility = ''; d.style.pointerEvents = ''; d.style.transform = ''; }
      });
    }
  });
}

function initProductGallery() {
  document.querySelectorAll('[data-an-gallery]').forEach(function (gallery) {
    var main = gallery.querySelectorAll('.an-product__main img');
    var thumbs = gallery.querySelectorAll('.an-product__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.dataset.index;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        main.forEach(function (img) { img.classList.toggle('is-active', img.dataset.index === idx); });
      });
    });
  });
}

function initVariantPicker() {
  document.querySelectorAll('[data-an-variant-picker]').forEach(function (root) {
    var variantsData = JSON.parse(root.querySelector('[data-an-variants-json]').textContent);
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-an-price]');
    var compareEl = root.querySelector('[data-an-compare]');
    var addBtn = root.querySelector('[data-an-add-btn]');
    var stockMsg = root.querySelector('[data-an-stock-msg]');
    var galleryRoot = document.querySelector('[data-an-gallery]');
    var optionEls = root.querySelectorAll('[data-an-option]');
    var moneyFormat = root.dataset.anMoneyFormat || '{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(0);
      var withSeparators = amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return moneyFormat.replace(/\{\{\s*amount\w*\s*\}\}/, withSeparators);
    }

    function getSelected() {
      var selected = [];
      optionEls.forEach(function (optGroup) {
        var active = optGroup.querySelector('.is-active');
        selected.push(active ? active.dataset.value : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return variantsData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function refreshAvailability() {
      var selected = getSelected();
      optionEls.forEach(function (optGroup, groupIndex) {
        var controls = optGroup.querySelectorAll('[data-value]');
        controls.forEach(function (ctrl) {
          var testSelection = selected.slice();
          testSelection[groupIndex] = ctrl.dataset.value;
          var possible = variantsData.some(function (v) {
            return v.options.every(function (opt, i) {
              return testSelection[i] === null || opt === testSelection[i];
            });
          });
          ctrl.classList.toggle('is-disabled', !possible);
        });
      });
    }

    function updateUI() {
      var selected = getSelected();
      var variant = findVariant(selected);
      refreshAvailability();
      if (!variant) {
        if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = addBtn.dataset.unavailableText || 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (variant.featured_image && galleryRoot) {
        var thumb = galleryRoot.querySelector('.an-product__thumb[data-image-id="' + variant.featured_image + '"]');
        if (thumb) thumb.click();
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = addBtn.dataset.addText || 'Añadir al carrito';
          if (stockMsg) stockMsg.textContent = '';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = addBtn.dataset.soldOutText || 'Agotado';
          if (stockMsg) stockMsg.textContent = stockMsg.dataset.soldOutMsg || '';
        }
      }
    }

    optionEls.forEach(function (optGroup) {
      optGroup.querySelectorAll('[data-value]').forEach(function (ctrl) {
        ctrl.addEventListener('click', function () {
          if (ctrl.classList.contains('is-disabled')) return;
          optGroup.querySelectorAll('[data-value]').forEach(function (c) { c.classList.remove('is-active'); });
          ctrl.classList.add('is-active');
          var labelTarget = optGroup.querySelector('[data-an-selected-label]');
          if (labelTarget) labelTarget.textContent = ctrl.dataset.value;
          updateUI();
        });
      });
    });

    updateUI();
  });
}

function initQty() {
  document.querySelectorAll('.an-qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        val = btn.dataset.dir === 'up' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
}

function initAccordion() {
  document.querySelectorAll('.an-accordion__item').forEach(function (item) {
    var head = item.querySelector('.an-accordion__head');
    if (!head) return;
    head.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.an-accordion__item').forEach(function (i) { i.classList.remove('is-open'); });
      if (!isOpen) item.classList.add('is-open');
    });
  });
}

function initZoom() {
  document.querySelectorAll('[data-an-zoom-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var activeImg = document.querySelector('.an-product__main img.is-active');
      if (!activeImg) return;
      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:999;background:rgba(10,10,9,0.96);display:flex;align-items:center;justify-content:center;cursor:zoom-out;padding:20px;';
      var img = document.createElement('img');
      img.src = activeImg.src.replace(/width=\d+/, 'width=1800');
      img.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;';
      overlay.appendChild(img);
      overlay.addEventListener('click', function () { overlay.remove(); });
      document.body.appendChild(overlay);
    });
  });
}

function initReviewsScroll() {
  document.querySelectorAll('[data-an-reviews]').forEach(function (root) {
    var track = root.querySelector('.an-reviews-track');
    var prev = root.querySelector('[data-an-reviews-prev]');
    var next = root.querySelector('[data-an-reviews-next]');
    if (!track) return;
    function scrollAmount() {
      var card = track.querySelector('.an-review-card');
      return card ? card.offsetWidth + 18 : 300;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });
}
